import { css } from "@emotion/react";
import { RainbowKitWalletButton } from "../../../../Header/ConnectWallet/RainbowKitWalletButton";
import styled from "@emotion/styled";
import { GetExactPriceIcon, TradeMultipleTokensIcon } from "components/Icons";
import { useIsMobile } from "hooks/useDeviceType";

interface ProfileActionsContentNoConnectionProps {
  closeDisplay: () => void;
}

export const ProfileActionsContentNoConnection = ({
  closeDisplay,
}: ProfileActionsContentNoConnectionProps) => {
  const isMobile = useIsMobile();

  const TradeMultipleTokensText = () => (
    <div>
      <BodyTitle>Trade multiple tokens, all at once</BodyTitle>
      <BodyParagraph>Save on network fees. Get in and out of positions quickly.</BodyParagraph>
    </div>
  );

  const ExactPriceText = () => (
    <div>
      <BodyTitle>Get the exact price you see</BodyTitle>
      <BodyParagraph>
        What you see is exactly what you get. Network fees included, nothing on top.
      </BodyParagraph>
    </div>
  );

  return (
    <>
      <Container>
        {!isMobile && <Title>Start trading now</Title>}
        <Body>
          <BodyRow>
            <IconContainer>
              <TradeMultipleTokensIcon />
            </IconContainer>
            <TradeMultipleTokensText />
          </BodyRow>
          <BodyRow>
            <IconContainer>
              <GetExactPriceIcon />
            </IconContainer>
            <ExactPriceText />
          </BodyRow>
        </Body>
      </Container>
      <div onClick={closeDisplay}>
        <RainbowKitWalletButton border="sharp" css={walletButtonMobileCss} />
      </div>
    </>
  );
};

// Sub-components

const Container = styled.div`
  padding: 16px 10px 24px 10px;
`;

const Title = styled.h1`
  font-size: ${props => props.theme.fontSize[7]};
  font-weight: ${props => props.theme.fontWeights["work-sans-0"]};
  text-align: center;
  margin-bottom: 16px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  padding-right: 12px;
`;

const BodyRow = styled.div`
  display: flex;
  gap: 10px;
`;

const BodyTitle = styled.h1`
  font-size: ${props => props.theme.fontSize[5]};
  line-height: ${props => props.theme.lineHeights[2]};
  font-weight: ${props => props.theme.fontWeights["work-sans-0"]};
`;

const BodyParagraph = styled.p`
  font-size: ${props => props.theme.fontSize[4]};
  font-weight: ${props => props.theme.fontWeights["work-sans-2"]};
  margin-bottom: 0;
  line-height: ${props => props.theme.lineHeights[6]};
`;

const IconContainer = styled.div`
  width: 40px;
  height: 40px;
`;

// Helpers

const walletButtonMobileCss = css`
  padding: 13px 16px 13px 10px;
`;
